module.exports = __webpack_public_path__ + "static/media/camera-outline.0fc96ede.svg";